
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-inspection",
      function () {
        return require("private-next-pages/car-inspection/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car-inspection"])
      });
    }
  